module.exports = __webpack_public_path__ + "static/media/add.1c09f38f.svg";